'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { isEmpty } from 'lodash-es'
import { useForm, useWatch } from 'react-hook-form'

import { Button, Form } from '@/shared/ui'

import { useResetPassword } from '../api/reset-password'
import {
  TResetPasswordForm,
  ZResetPasswordForm,
  defaultValues,
} from '../model/form'

type Props = {
  certNum: string
  onSuccess: () => void
}

export const ResetPasswordForm = ({ certNum, onSuccess }: Props) => {
  const form = useForm<TResetPasswordForm>({
    resolver: zodResolver(ZResetPasswordForm),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  })

  const [newPassword, newPasswordConfirm] = useWatch({
    control: form.control,
    name: ['newPassword', 'newPasswordConfirm'],
  })

  const isDisabled = !newPassword || !newPasswordConfirm

  const resetPassword = useResetPassword({
    form,
    onSuccess,
  })

  const submitForm = ({ newPassword }: TResetPasswordForm) => {
    resetPassword.execute({ newPassword, certNum })
  }

  const handlePasswordChange = () => {
    const isPasswordMatchError =
      !!form.formState.errors.newPasswordConfirm && !isEmpty(newPasswordConfirm)

    if (isPasswordMatchError) {
      form.clearErrors('newPasswordConfirm')
    }
  }

  return (
    <Form.Root form={form}>
      <Form.Field name="newPassword" onChange={handlePasswordChange}>
        <Form.Label className="font-medium text-black">
          신규 비밀번호
        </Form.Label>
        <Form.PasswordField
          placeholder="영문, 숫자 조합 6자-15자를 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="newPasswordConfirm" className="mt-6">
        <Form.Label className="font-medium text-black">
          신규 비밀번호 확인
        </Form.Label>
        <Form.PasswordField
          placeholder="비밀번호를 재입력 해주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Button
        size="large"
        className="mt-10"
        type="submit"
        fullWidth
        onClick={form.handleSubmit(submitForm)}
        disabled={isDisabled}
      >
        확인
      </Button>
    </Form.Root>
  )
}
